import Alert from '@mui/material/Alert';
import Snackbar, { SnackbarCloseReason } from '@mui/material/Snackbar';
import { useEffect, useState } from 'react';

type SnackbarProps = {
  content: string;
  show: boolean;
  type: 'error' | 'success';
  handleCloseAlert: (show: boolean) => void;
}

const SnackbarNotify: React.FC<SnackbarProps> = (props) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setOpen(true)
  }, [props.show])

  const handleClose = (
    event?: React.SyntheticEvent | Event,
    reason?: SnackbarCloseReason
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    props.handleCloseAlert(false)
    setOpen(false);
  };

  return (
    <div>
      <Snackbar
        open={open}
        autoHideDuration={2000}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        sx={{zIndex: 2147483648}}
      >
        <Alert
          onClose={handleClose}
          severity={props.type}
          variant='filled'
          sx={{ width: '100%' }}
        >
          {props.content}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default SnackbarNotify;
